export default {
  close_date: {
    formFieldName: ['_error', 'hour', 'minute', 'isAm', 'timezone'],
    errors: {
      TimeHasPassed: 'Time is referring to the past.',
    },
  },
};
